/**
 * domain 字典实现
 */
import Dictionary from "../dictionary";
import DictionaryFactory from "../dictionary-factory";
import DomainalnApi from '@/api/domainaln';

export const DICTIONARY_FACTORY_DOMAIN = 'domain';
export default class DomainDictionaryFactory extends DictionaryFactory {
    constructor() {
        super({name: DICTIONARY_FACTORY_DOMAIN});
    }

    async getDictionary(domainId) {
        let domains = [];
        await DomainalnApi.list({domainid: domainId}).then(responseBody => {
            domains = responseBody;
        });
        return new Dictionary({items: domains, valueKey: 'value', textKey: 'description'});
    }
}